import { render } from "./TicketComponent.vue?vue&type=template&id=1a4310aa&scoped=true"
import script from "./TicketComponent.vue?vue&type=script&lang=js"
export * from "./TicketComponent.vue?vue&type=script&lang=js"

import "./TicketComponent.vue?vue&type=style&index=0&id=1a4310aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4310aa"]])

export default __exports__